/** INFO
 * 해당 모달은 반복 조건을 설정할 때 사용하는 모달입니다.
 * - `삭제하기` 버튼을 클릭하면, 모달에서 선택한 옵션에 따라 반복 예약을 삭제합니다.
 * - 삭제가 완료되면, 모달을 닫고, onDelete 콜백을 호출합니다.
 */

import { RepeatReservationConditionalOption } from "../repeat-edit-conditinal-modal";

export type RepeatRuleSettingModalProps = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onSetting?: (rrule?: TRRule) => void;
  selectedDate?: Date;
  editOption?: RepeatReservationConditionalOption;
  selectedRrule?: TRRule;
  minCount?: number;
};

export enum RepeatUnit {
  WEEK = "주",
  DAY = "일",
  WEEKDAYS = "주중(월-금) 매일",
  MONTH = "월",
}

export enum RepeatWeekday {
  MON = "월",
  TUE = "화",
  WED = "수",
  THU = "목",
  FRI = "금",
  SAT = "토",
  SUN = "일",
}

export enum RepeatEndOption {
  DATE = "날짜",
  TIMES = "횟수",
}

export enum RepeatRuleOption {
  NTH_WEEKDAY = "NTH_WEEKDAY",
  SPECIFIC = "SPECIFIC",
}

export type TRRule = {
  repeatUnit: RepeatUnit;
  interval: number;
  repeatEndOption: RepeatEndOption;
  repeatCount?: number;
  endDate?: Date;
  repeatWeekdays?: string[];
  repeatRuleOption?: RepeatRuleOption;
};
